<template>
    <div class="tablelist">

        <div class="uploadBlock" v-if="this.action == 'list'">

            <template v-if="C.Env != 'pro'">
                <a-button  type="primary" @click="handleCompare()" >测试环境同步
                </a-button>
            </template>

            <a-button
                type="primary"

                @click="handleExportService('export_all')"
                :loading="isExporting"
            >导出全部
            </a-button>

            <a-button
                type="primary"

                @click="handleExportService('export_select')"
                :loading="isExporting"
            >导出选中
            </a-button>

            <a-tooltip placement="top">
                <template slot="title">
                    <span>servicekey已存在的记录会被忽略</span>
                </template>
                <a-upload
                    name="file"
                    :multiple="true"
                    action="'http://192.168.1.63:9000/data/"
                    :headers="headers"
                    :data="handleImportFile"
                    @change="handleChange"
                >
                    <a-button type="primary" :loading="isImporting">
                        <a-icon type="upload"/>
                        导入
                    </a-button>
                </a-upload>
            </a-tooltip>


        </div>
        <a-table
            size="middle"
            :key="this.loading.key"
            :columns="columns"
            :rowKey="c_row_key"
            :dataSource="list"
            :pagination="false"
            :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange ,type:rowsType}"
            :scroll="{ x: clientWidth}"
        >
            <template slot="operation" slot-scope="text,record">
                <router-link
                    :data-track="record.servicekey"
                    class="mr10"
                    :to="{
                    path:'edit',
                    query: {
                        id: record.id,
                        //这里注意this的作用域指向问题
                        referer: JSON.stringify(that.$route.query),
                    }
                }"
                >编辑
                </router-link>
                <a-popconfirm title="确认删除?" :data-track="record.servicekey" @confirm="() => onDelete(record)" v-if="G.isUserAdmin()" style="margin-right:10px;">
                    <a :disabled="that.loading.effects[deleteType]" href="javascript:;">删除</a>
                </a-popconfirm>
                <router-link
                    :to="{
                    path:'copy',
                    query: {
                        id: record.id,
                        urlparams:false
                    }
                }"
                >复制</router-link>
            </template>

            <template slot="operationforjibie" slot-scope="text,record">
                <a @click="e => singlesetting(record)" class="mr10">设置</a>
                <a @click="e => singleupdate(record)">修改</a>
            </template>

            <!-- 修改日志级别 -->
            <template slot="rizhiupdate" slot-scope="text,record">
                <a-select
                    style="width:120px"
                    :defaultValue="text"
                    @change="value => that.updatelevel(value, record)"
                >
                    <a-select-option key="INFO">INFO</a-select-option>
                    <a-select-option key="ERROR">ERROR</a-select-option>
                    <a-select-option key="DEBUG">DEBUG</a-select-option>
                </a-select>
            </template>

            <template slot="appcodet" slot-scope="text, record">
            <span>
                <router-link
                    v-if="record.routeflag == 0"
                    :to="{
                    path:'/monitorservice/servicesum',
                    query: {
                        appcode: record.appcode,
                        serviceconfig:record.serviceconfig
                    }
                }"
                >查看</router-link>
                <span v-else>--</span>
            </span>
            </template>

            <template slot="invoks" slot-scope="text, record">
            <span>
                <router-link
                    :to="{
                    path:'/servicekey/list',
                    query: {
                        routeservicekey: record.servicekey,
                    }
                }"
                >查看</router-link>
            </span>
            </template>

            <template slot="routeLink" slot-scope="text, record">
            <span>
                <router-link
                    :to="{
                    path:'/servicekey/list',
                    query: {
                        keyword:record.routeservicekey
                    }
                }"
                >{{text}}</router-link>
            </span>
            </template>

            

        </a-table>
        <!-- 表格的页脚  -->
        <div v-if="this.action == 'jibie'" style="margin-top:20px;">
            <a-button @click="batsetting" type="primary" class="mr18">批量设置</a-button>
            <a-button @click="batupdate" type="primary" class="mr18">批量修改</a-button>
            <a-button @click="batsettingbylevel" type="primary" class="mr18">按级别批量设置</a-button>

            <a-modal
                :visible="showSettingModal"
                :destroyOnClose="true"
                @cancel="handleCancel"
                @ok="handleOkSetting"
                title="批量设置"
            >
                <a-form layout="inline" :form="formsetting" class="formitem">
                    <a-form-item label="服务级别" v-if="grouplevel">
                        <a-select
                            placeholder="请选择级别"
                            style="width:200px;"
                            v-decorator="[
                                    'servicelevel',
                                    {
                                        rules:[{required:true, message: '请选择服务级别'}]
                                    }
                                ]"
                        >
                            <a-select-option key="0">级别0</a-select-option>
                            <a-select-option key="1">级别1</a-select-option>
                            <a-select-option key="2">级别2</a-select-option>
                        </a-select>
                    </a-form-item>

                    <a-form-item label="上下线状态">
                        <a-radio-group
                            v-decorator="[
                                    'serviceflag',
                                    {
                                        initialValue: singleRecord.serviceflag || undefined,
                                        rules:[{required: true, message: '状态必选'}]
                                    }
                                ]"
                        >
                            <a-radio value="1">正常</a-radio>
                            <a-radio value="0">禁用</a-radio>
                        </a-radio-group>
                    </a-form-item>
                </a-form>
            </a-modal>

            <a-modal
                :visible="showUpdateModal"
                :destroyOnClose="true"
                @cancel="handleCancel"
                @ok="handleOkUpdate"
                title="批量修改"
            >
                <a-form layout="inline" :form="formupdate" class="formitem">
                    <a-form-item label="服务级别">
                        <a-select
                            placeholder="请选择级别"
                            v-decorator="[
                                    'servicelevel',
                                    {
                                        initialValue: singleRecord.servicelevel || undefined,
                                        rules: [{ required: true, message: '请选择' }]
                                    }
                                ]"
                            style="width:200px;"
                        >
                            <a-select-option key="0">级别0</a-select-option>
                            <a-select-option key="1">级别1</a-select-option>
                            <a-select-option key="2">级别2</a-select-option>
                        </a-select>
                    </a-form-item>
                </a-form>
            </a-modal>
        </div>

        <a-pagination style="margin-top:40px;float:right;margin-bottom:40px;" v-model="pagination.current"
                      :total="pagination.total" @change="handlePageChange" show-less-items show-quick-jumper/>

    </div>
</template>

<script>
const storeNamespace = "servicekey";
const routName = {
    '001':'前台',
    '002':'中台',
    '003':'开放',
    '004':'基础'
}
export default {
    data() {
        return {
            clientWidth:800,
            that: this,
            storeNamespace,
            selectType: `${storeNamespace}/select`,
            deleteType: `${storeNamespace}/del`,
            columns: [],
            action: "",
            selectedRowKeys: [],
            c_row_key: '',
            rowsType: 'checkbox',
            grouplevel: false,

            singleRecord: {},

            formsetting: this.$form.createForm(this),
            formupdate: this.$form.createForm(this),

            showSettingModal: false, //批量设置的modal
            showUpdateModal: false, //批量修改的modal
            exportId: '',
            importId: '',
            isExporting: false,
            isImporting: false,
            checkStatuesTime: 0,
            headers: {
                authorization: 'authorization-text',
            },
            pagination: {
                total: 0,
                pageSize: 10,
                current: 1,
            },
            list: [],
        };
    },
    methods: {
        handleCompare(){
            const {query} = this.$route;

            this.$router.push({
                path: 'compare',
                query: query
            });
        },
        handlePageChange(params_page) {
            this.onModalInit(params_page)
        },
        onSelectChange(selectedRowKeys) {
            this.selectedRowKeys = selectedRowKeys;
        },
        onModalInit(current_page) {
            if (this.action == "list") {
                this.columns = [
                    {
                        title: "序号",
                        width: 50,
                        align: "center",
                        customRender: (text, record, index) => ++index,
                    },
                    
                    {
                        title: "应用编码",
                        dataIndex: "appcode",
                        align: "center",
                        width: 100
                    },
                    {
                        title: "所属领域",
                        dataIndex: "domaindesc",
                        align: "center",
                        width: 80
                    },
                    
                    {
                        title: "服务KEY",
                        dataIndex: "servicekey",
                        align: "left",
                        width: 380
                    },
                    {
                        title: "服务配置",
                        dataIndex: "serviceconfig",
                        align: "left",
                        width: 480
                    },
                    {
                        title: "统计",
                        align: "center",
                        width: 50,
                        scopedSlots: {customRender: "appcodet"},
                        // fixed: 'right'
                    },
                    {
                        title: "调用方",
                        align: "center",
                        width: 60,
                        scopedSlots: {customRender: "invoks"},
                        // fixed: 'right'
                    },
                    {
                        title: "路由其它领域",
                        dataIndex: "routeflag",
                        align: "center",
                        customRender: text => (text == "1" ? "是" : "否"),
                        width: 100
                    },
                    {
                        title: "路由领域",
                        dataIndex: "routedomain",
                        align: "center",
                        customRender: text => (routName[text]),
                        width: 100
                    },
                    {
                        title: "关联其它领域服务",
                        align: "left",
                        dataIndex: "routeservicekey",
                        scopedSlots: {customRender: "routeLink"},
                        width: 380
                    },
                    {
                        title: "服务描述",
                        align: "left",
                        dataIndex: "servicedesc",
                        width: 200,
                        ellipsis: true,
                    },
                    {
                        title: "分支",
                        dataIndex: "targetbranch",
                        align: "center",
                        width: 80
                    },
                    {
                        title: "类型",
                        dataIndex: "interfacetype",
                        align: "center",
                        width: 80
                    },
                    {
                        title: "免鉴权",
                        dataIndex: "entry",
                        align: "center",
                        customRender: text => (text == "1" ? "是" : "否"),
                        width: 80
                    },
                    {
                        title: "收费",
                        dataIndex: "ischarge",
                        align: "center",
                        customRender: text => (text == "1" ? "是" : "否"),
                        width: 80
                    },
                    {
                        title: "验签",
                        dataIndex: "encryptflag",
                        align: "center",
                        customRender: text => (text == "1" ? "是" : "否"),
                        width: 80
                    },
                    {
                        title: "状态",
                        dataIndex: "serviceflag",
                        align: "center",
                        customRender: text => (text == "1" ? "上线" : "下线"),
                        width: 80
                    },
                {
                    title: "参数处理",
                    dataIndex: "parameter",
                    align: "center",
                    customRender: text => (text == "1" ? "是" : "否"),
                    width: 80
                },
                    {
                        title: "参数转换配置",
                        align: "left",
                        dataIndex: "parameterways",
                        width: 200,
                        ellipsis: true,
                    },
                    {
                        title: "参数转换条件",
                        align: "left",
                        dataIndex: "parameterconditions",
                        width: 200,
                        ellipsis: true,
                    },
                    {
                        title: "负责人",
                        align: "center",
                        dataIndex: "serviceadmin",
                        width: 80
                    },
                    {
                        title: "创建时间",
                        align: "center",
                        dataIndex: "createtime",
                        width: 180
                    },
                    {
                        title: "更新时间",
                        align: "center",
                        dataIndex: "updatetime",
                        width: 180
                    },

                    {
                        title: "操作",
                        width: 150,
                        scopedSlots: {customRender: "operation"},
                        align:'center',
                        fixed: 'right'
                    },

                ];
            } else if (this.action == "jibie") {
                this.columns = [
                    {
                        title: "序号",
                        width: 80,
                        align: "center",
                        customRender: (text, record, index) => ++index
                    },
                    {
                        title: "所属领域",
                        dataIndex: "domaindesc",
                        width: 80
                    },
                    {
                        title: "AppCode",
                        dataIndex: "appcode",
                    },
                    {
                        title: "服务KEY",
                        dataIndex: "servicekey"
                    },
                    {
                        title: "服务级别",
                        dataIndex: "servicelevel"
                    },
                    {
                        title: "上下线状态",
                        dataIndex: "serviceflag",
                        customRender: text => (text == "1" ? "上线" : "下线")
                    },
                    {
                        title: "接口类型",
                        dataIndex: "interfacetype"
                    },
                    {
                        title: "创建时间",
                        dataIndex: "createtime"
                    },
                    {
                        title: "操作",
                        width: 146,
                        scopedSlots: {customRender: "operationforjibie"}
                    }
                ];
            } else if (this.action == "level") {
                this.columns = [
                    {
                        title: "序号",
                        width: 80,
                        align: "center",
                        customRender: (text, record, index) => ++index
                    },
                    {
                        title: "系统名称",
                        dataIndex: "systemname"
                    },
                    {
                        title: "root日志级别",
                        dataIndex: "rootlevel",
                        scopedSlots: {customRender: "rizhiupdate"}
                    }
                ];
            }

            switch (this.action) {
                case "list":
                    this.selectType = `${storeNamespace}/select`;
                    this.c_row_key = 'id'
                    break;
                case "jibie":
                    this.selectType = `${storeNamespace}/jibie`;
                    this.c_row_key = 'id'
                    break;
                case "rizhi":
                    this.selectType = `${storeNamespace}/rizhi`;
                    this.c_row_key = 'id'
                    break;
                default:
                    break;
            }
            current_page = current_page ? current_page : 1;
            const {query} = this.$route;
            let c_params = {
                pageSize: this.pagination.pageSize,
                page: current_page,
                urlparams: false,
                ...query
            }
            let that = this;
            this.$store.dispatch({
                type: that.selectType,
                params: c_params
            }).then((res) => {
                let result = res.data.data;
                that.list = result.list;
                that.pagination.total = result.totalRecords;
                that.pagination.pageSize = result.pageSize;
                that.pagination.current = result.page;
            });
        },
        //设置单个服务级别
        singlesetting(record) {
            console.log(record);
            this.grouplevel = false;
            this.singleRecord = record;
            this.batsetting(false);
        },

        //修改单个服务级别
        singleupdate(record) {
            console.log(record);
            this.grouplevel = false;
            this.singleRecord = record;
            this.batupdate(false);
        },
        //初始化相关数据
        initSelectRecords() {
            this.selectedRowKeys = [];
            this.singleRecord = {};
            this.grouplevel = false;
            this.onModalInit(this.pagination.current)
        },
        //显示modal
        showModal(whichModal) {
            this[whichModal] = true;
        },
        //关闭modal
        handleCancel() {
            this.showSettingModal = false;
            this.showUpdateModal = false;
            this.grouplevel = false;
        },
        //保存批量修改
        handleOkUpdate() {
            this.formupdate.validateFields((err, values) => {
                if (err) return;
                if (this.singleRecord["id"]) {
                    //单个设置项
                    values["ids"] = this.singleRecord["id"];
                } else {
                    //批量设置
                    values["ids"] = this.selectedRowKeys.join(",");
                }

                this.handleCancel();
                console.log(
                    values,
                    "handleOkSettinghandleOkSettinghandleOkSetting"
                );
                this.$store
                    .dispatch({
                        type: `${storeNamespace}/batupdate`,
                        params: values
                    })
                    .then(() => {
                        this.initSelectRecords();
                    });
            });
        },
        //保存批量设置
        handleOkSetting() {
            this.formsetting.validateFields((err, values) => {
                if (err) return;
                if (this.grouplevel === false) {
                    if (this.singleRecord["id"]) {
                        //单个设置项
                        values["ids"] = this.singleRecord["id"];
                    } else {
                        //批量设置
                        values["ids"] = this.selectedRowKeys.join(",");
                    }
                } else {
                    delete values.ids;
                }
                this.handleCancel();
                console.log(
                    values,
                    "handleOkSettinghandleOkSettinghandleOkSetting"
                );
                this.$store
                    .dispatch({
                        type: `${storeNamespace}/batsetting`,
                        params: values
                    })
                    .then(() => {
                        this.initSelectRecords();
                    });
            });
        },
        //更新日志级别
        updatelevel(value, record) {
            console.log(value, record);
            record.rootlevel = value;
            this.$store.dispatch({
                type: `${storeNamespace}/rizhiupdate`,
                params: record
            });
        },
        //删除
        onDelete(record) {
            this.$store.dispatch({
                type: this.deleteType,
                params: record
            }).then(() => {
                this.initSelectRecords();
            });
        },
        //检测是否允许点击批量的按钮
        isAllowBat() {
            if (this.selectedRowKeys.length <= 0) {
                this.message.info("请先选择需要修改的数据");
                return false;
            }
            return true;
        },
        //批量设置
        batsetting(checkSelected = true) {
            if (checkSelected && !this.isAllowBat()) return false;
            this.showModal("showSettingModal");
        },
        //按级别批量设置
        batsettingbylevel() {
            this.grouplevel = true;
            this.showModal("showSettingModal");
        },
        //批量修改
        batupdate(checkSelected = true) {
            if (checkSelected && !this.isAllowBat()) return false;
            this.showModal("showUpdateModal");
        },
        handleImportFile(file) {
            // let that = this;
            let result = this.D.syncSelect({
                type: 'servicekey/importConfig',
                params: {}
            })
            if (result.success !== '1') {
                // that.message.error(result['errorMsg']);
                return false;
            }
            const data = result.data;
            const {
                dir,
                policy,
                accessid,
                callback,
                signature
            } = data;
            const token = {
                policy: policy,
                OSSAccessKeyId: accessid,
                success_action_status: '200',
                callback: callback,
                signature: signature
            };
            const objName = dir + this.getUniqueCode() + this.getSuffix(file.name);
            file.objName = objName;
            return {
                ...token,
                key: objName
            }

        },
        getUniqueCode() {
            const s = [];
            const hexDigits = "0123456789abcdef";
            for (let i = 0; i < 36; i++) {
                s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
            }
            s[14] = "4";
            s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);
            s[8] = s[13] = s[18] = s[23] = "-";
            return s.join("");
        },
        getSuffix(filename) {
            const pos = filename.lastIndexOf('.');
            let suffix = '';
            if (pos !== -1) {
                suffix = filename.substring(pos)
            }
            return suffix;
        },
        //上传文件结果处理
        handleChange(info) {
            if (info.file.status !== 'uploading') {
                console.log(info.file, info.fileList);
            }
            if (info.file.status === 'done') {
                this.saveImportRecord(info.file.objName, info.file.originFileObj.name);
                this.message.success(`${info.file.name} file uploaded successfully`);

            } else if (info.file.status === 'error') {
                this.message.error(`${info.file.name} file upload failed.`);
            }
        },
        handleImportTest() {
            this.saveImportRecord('attachment_openapi/20200927/fad37e2c-af1d-45d9-8ec8-5748051c0296.xls', '单规格商品导入模板.xls')
        },
        saveImportRecord(fileUrl, filename) {
            this.isImporting = true;
            this.$store
                .dispatch({
                    type: 'servicekey/saveImportService',
                    params: {
                        importbusinesstype: 'importServiceList',
                        shopcode: '125806668',
                        loginuserbranchcode: '1001',
                        sourcefile: fileUrl,
                        filename: filename,
                        syncstatus: 1,
                        updownstatus: 1,
                    }
                })
                .then((res) => {
                    if (res.data.success == '1') {
                        console.log(res)
                        this.importId = res.data.data
                        this.checkImportStatue();

                        //刷新页面
                        this.$router.push({
                            path: this.action,
                            query: ''
                        });

                    } else {
                        this.isImporting = false;
                        this.message.error('导入失败')
                    }

                }).catch((e) => {
                    this.isImporting = false;
                    this.message.error('导入失败' + e.message)
                });
        },
        checkImportStatue() {
            if (this.checkStatuesTime > 3) {
                this.message.error('超出请求次数')
                this.checkStatuesTime = 0;
                clearTimeout(this.timer)
                this.isImporting = false
                return;
            }
            let that = this;
            this.timer = setTimeout(function () {
                that.$store
                    .dispatch({
                        type: 'servicekey/checkImportStatue',
                        params: {id: that.importId}
                    })
                    .then((res) => {
                        if (res.data.success == 1) {
                            if (res.data.data.importstatus == 1) {
                                //导入成功
                                that.isImporting = false
                                console.log(res)

                            } else if (res.data.data.importstatus == 2) {
                                that.isImporting = false
                                that.message.error(res.data.data.errormsg)
                            } else {
                                that.checkImportStatue()
                            }
                        } else {
                            that.checkImportStatue()
                        }
                        console.log(res)
                        that.checkStatuesTime++
                    });
            }, 2000);

        },
        handleExportService(flag) {


            let exportIds = this.selectedRowKeys.join(',')
            if (flag == 'export_select') {
                //导出选中
                if (!exportIds) {
                    this.message.error('请勾选需要导出的列')
                    return
                }
            } else {
                //导出所有
                if (exportIds) {
                    this.message.error('导出所有时，请不要选中列')
                    return
                }
            }
            const {query} = this.$route;
            this.isExporting = true
            this.$store
                .dispatch({
                    type: 'servicekey/exportService',
                    params: {
                        shopcode: '125806668',
                        loginuserbranchcode: '1001',
                        exportbusinesstype: 'exportServiceList',
                        exportparamsdesc: '{}',
                        ...query,
                        exportids: exportIds
                    }
                })
                .then((res) => {
                    if (res.data.success == '1') {
                        console.log(res)
                        this.exportId = res.data.data
                        this.checkExportStatue();

                    } else {
                        this.isExporting = false;
                        this.message.error('导出失败')
                    }
                }).catch((e) => {
                    this.isExporting = false;
                    this.message.error('导出失败' + e.message)
                });
        },

        checkExportStatue() {
            if (this.checkStatuesTime > 3) {
                this.message.error('超出请求次数')
                this.checkStatuesTime = 0;
                clearTimeout(this.timer)
                this.isExporting = false
                return;
            }
            let that = this;
            this.timer = setTimeout(function () {
                that.$store
                    .dispatch({
                        type: 'servicekey/checkExportStatue',
                        params: {id: that.exportId}
                    })
                    .then((res) => {
                        if (res.data.success == 1) {
                            if (res.data.data.exportstatus == 1) {
                                //导出成功
                                that.isExporting = false
                                let temp_File_Str = res.data.data.exportfilefull;
                                let files = temp_File_Str.split(',')
                                for (let index = 0; index < files.length; index++) {
                                    const element = files[index];
                                    window.open(element)
                                }

                            } else {
                                that.checkExportStatue()
                            }
                        } else {
                            that.checkExportStatue()
                        }
                        console.log(res)
                        that.checkStatuesTime++
                    });
            }, 2000);

        }

    },
    computed: {},
    beforeMount() {
        const {path} = this.$route;
        this.action = path.split("/").pop();
    },
    mounted() {
        this.onModalInit()
    }
};
</script>
<style lang="less" scoped>
.uploadBlock {
    width: 400px;
    height: 40px;
    margin-top: 8px;
    text-align: right;
    position: absolute;
    top: 17px;
    right:90px;
}

.uploadBlock button {
    margin-right: 12px;
}

</style>
